exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-farm-sidebar .mat-tab-label .mat-ripple .mat-tab-label-active {\n  color: #4caf50;\n  text-transform: uppercase; }\n\napp-farm-sidebar .mat-tab-label-content {\n  color: #4caf50; }\n\napp-farm-sidebar .mat-tab-group.mat-primary .mat-ink-bar,\napp-farm-sidebar .mat-tab-nav-bar.mat-primary .mat-ink-bar {\n  color: #448aff;\n  background: #448aff; }\n\napp-farm-sidebar .sidebar-header {\n  padding: 8px; }\n", ""]);

// exports
